import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { PlusSource } from 'sources'
import { UserActions, Analytics } from 'common-frontend'
import { AnalyticsUtils } from 'utils'
import { GlobalErrorActions } from 'actions'

@createActions(alt)
export default class CheckActions {
  constructor() {
    this.generateActions(
      'setPlus',
      'setInstalling',
      'setFailed',
      'setIsUpgrade'
    )
  }

  fetch() {
    return PlusSource.fetch()
      .then(status => this.setPlus({
        status,
        installed: false
      }))
  }

  install(currentUser, isUpgrade, type) {
    setTimeout(() => {
      this.setInstalling(true)
      this.setFailed(false)
      this.setIsUpgrade(isUpgrade)

      if (isUpgrade) {
        this.upgradeCode(currentUser)
      } else {
        this.installCode(currentUser, type)
      }
    }, 0)
  }

  upgradeCode(currentUser) {
    return PlusSource.upgrade()
      .then(status => {
        AnalyticsUtils.upgradedCode(currentUser.email)
        this.setPlus({ status, installed: true, isUpgrade: true})
        this.setInstalling(false)
      }).catch(() => {
        AnalyticsUtils.upgradeCodeFailed(currentUser.email)
        this.setFailed(true)
        this.setInstalling(false)
      })
  }

  installCode(currentUser, type) {
    AnalyticsUtils.installedCode(currentUser.email, type)

    PlusSource.install(type == "complete")
      .then(status => {
        this.setPlus({ status, installed: true, isUpgrade: false})
        this.setInstalling(false)
      }).catch(() => {
        AnalyticsUtils.installCodeFailed(currentUser.email, type)
        this.setFailed(true)
        this.setInstalling(false)
      })
  }

  // The activeCharge: true property is set on the user on the server when the charge is activated
  // We just fire an analytics event here to trigger an email to be sent from Drip
  upgradeToPlus(currentUser) {
    Analytics.track('Upgraded to Plus')
    currentUser.activeCharge = true // reflect what has happened on the server without refreshing the whole user
    UserActions.setExtendedUser(currentUser)
    return true
  }

  selfInstall() {
    PlusSource.requestInstallation("self")
  }

  requestFreeInstallation() {
    Analytics.track("'Request installation' Button Clicked")
    PlusSource.requestInstallation("requestedViaEmail")
  }

  createPremiumSupportRequest() {
    Analytics.track("'Create Request' Button Clicked")
  }

  requestPlusInstall(currentUser) {
    AnalyticsUtils.plusInstallRequested(currentUser.shop, currentUser.email)
    PlusSource.requestInstallation("requestedViaAnalytic")
  }

  downgrade(currentUser) {
    return PlusSource.downgrade().then(resp => {
      currentUser.activeCharge = false
      UserActions.setExtendedUser(currentUser)
      Analytics.track('Downgraded from Plus')
    })
  }
}



// WEBPACK FOOTER //
// ./app/actions/PlusActions.js